<div class="visualizador-imagem">
  <header class="visualizador-imagem__header">
    <h2 mat-dialog-title class="visualizador-imagem__titulo">{{ data.titulo }}</h2>
    <button
      mat-icon-button
      type="button"
      class="visualizador-imagem__btn-fechar"
      matTooltip="Fechar (Esc)"
      (click)="fechar()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="visualizador-imagem__toolbar">
    <button
      mat-icon-button
      type="button"
      matTooltip="Diminuir zoom"
      [disabled]="zoom <= zoomMin"
      (click)="zoomOut()"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>
    <span class="visualizador-imagem__zoom-label">{{ zoomPercentual }}%</span>
    <button
      mat-icon-button
      type="button"
      matTooltip="Aumentar zoom"
      [disabled]="zoom >= zoomMax"
      (click)="zoomIn()"
    >
      <mat-icon>zoom_in</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      matTooltip="Restaurar (100%)"
      (click)="resetZoom()"
    >
      <mat-icon>fit_screen</mat-icon>
    </button>
    <span class="visualizador-imagem__dica">
      Ctrl + scroll para zoom
    </span>
  </div>

  <div class="visualizador-imagem__viewport">
    <img
      [src]="data.dataUrl"
      [alt]="data.alt || data.titulo"
      [style.transform]="'scale(' + zoom + ')'"
      class="visualizador-imagem__img"
      draggable="false"
    />
  </div>
</div>
